import { IRoutes } from '#/route/types';

export const routes: Array<IRoutes> = [
  { path: 'deposit', component: 'Deposit' },
  { path: 'withdrawal', component: 'Withdrawal' },
  { path: '*', component: 'page404' },
  // @ts-ignore
].filter(r => typeof r.use === 'undefined' || !!r.use);
